import { Currency } from '../types/Currencies';
import type { MakeCall } from '../createMakeCall';
import { PayInMethod, PaymentMethod, PaymentMethodDetail } from './types';

export type Payload = {
  methodType: PayInMethod;
  methodDetail?: PaymentMethodDetail;
  currency: Currency;
  token1?: string;
  pspName?: string;
};

export type Response = PaymentMethod;

const createPaymentMethod = (makeCall: MakeCall) => (data: Payload) =>
  makeCall<Response>('POST', `/api/v2/payment/method/pay-in`, { data });
export { createPaymentMethod };
